
import WDModelItems from '../wd-model-items';
import WDCarouselItem from './wd-carousel-item';
import WDElement from '../wd-element';

export default class WDCarousel extends WDElement
{

	#options = {
		model: {}
	};

	#carousel = null;
	#inner = null;
	#indicatorWrapper = null;

	constructor(opts)
	{
		super().classList.add('carousel', 'slide', 'wd-carousel');

		if (!opts?.model) opts.model = {data:[]};
		if (!opts?.model?.createItemHandler)
		{
			opts.model.createItemHandler = data => this.createSlide(data);
		}
		
		this.#inner = new WDModelItems(opts.model);
		this.#inner.classList.add('carousel-inner');
		this.append(this.#inner);

		Object.assign(this.#options, opts);

		this.addCarouselOptions(opts);
	};

	addCarouselOptions(opts)
	{
		if (opts?.interval !== undefined)
		{
			opts.ride = 'carousel';
			this.dataset.bsInterval = opts.interval;
		}

		if (opts?.keyboard) this.dataset.bsKeyboard = opts.keyboard;
		if (opts?.pause) this.dataset.bsPause = opts.pause;
		if (opts?.ride) this.dataset.bsRide = opts.ride;
		if (opts?.touch) this.dataset.bsTouch = opts.touch;

		if (opts?.fade) this.classList.add('carousel-fade');
	}

	connectedCallback()
	{
		super.connectedCallback();
		
		this.addEvents();
		this.initCarousel();

		if (this.#options?.showIndicators) this.addIndicators();
		if (this.#options?.showNav || this.#options?.showNavigation) this.addNavigation();
	};

	addEvents()
	{
		this.inner.on('item:added item:removed', () => this.updateIndicators());
		this.inner.on('items:added', () =>
		{
			this.trigger('items:added');

			setTimeout( () => {
				if (this.items.length > 0)
				{
					this.items[0].classList.add('active');
					this.items[0].trigger('slide:show');
					this.items[0].trigger('slide:shown');
				}
			},10);
			
		});

		this.inner.on('model:fetched',evt => this.trigger('model:fetched',evt.detail) );

		//use a custom content handler for the slide class
		if (this.#options?.contentHandler)
		{
			this.on('item:added', evt => this.#options.contentHandler(evt.detail));
		}

	}

	set createSlideHandler(val) { this.inner.createItemHandler = val; };
	get items() { return this.inner.children; };
	get itemArray() { return [...this.items]; };
	get inner() { return this.#inner; };
	get model() { return this.#inner.model; };
	set model(val) { this.#inner.model = val; };

	get carousel() { return this.#carousel; };
	get options() { return this.#options; };
	get indicators() { return this.#indicatorWrapper.children; };
	get curItem() { return this.#inner.querySelector('.active'); };
	get curItemIndex() { return this.itemArray.indexOf(this.curItem); };

	itemAt(idx) { return this.items[idx] || null; };
	indicatorAt(idx) { return this.indicators[idx] || null; };
	cycle() { this.carousel.cycle(); };
	pause() { this.carousel.pause(); };
	prev() { this.carousel.prev(); };
	next() { this.carousel.next(); };
	dispose() { this.carousel.dispose(); };
	view(itemNumber) { this.carousel.to(itemNumber); };

	fetchModel(wd) { return this.inner.fetchModel(wd); };

	/**
		reset the accordion back
		*/
	reset()
	{
		this.inner.reset();
		this.dispose();

		this.initCarousel();
	};

	initCarousel()
	{
		this.#carousel = new bootstrap.Carousel(this);
		this.addEventListener('slide.bs.carousel', (evt) =>
		{
			const obj = {
				direction: evt.direction,
				fromIndex: evt.from,
				toIndex: evt.to,
				from: this.items[evt.from],
				to: this.items[evt.to],
			};

			this.trigger('slide:begin', obj);
			this.updateActiveIndicator();
		});

		this.addEventListener('slid.bs.carousel', (evt) =>
		{
			const obj = {
				direction: evt.direction,
				fromIndex: evt.from,
				toIndex: evt.to,
				from: this.items[evt.from],
				to: this.items[evt.to],
			};

			this.trigger('slide:end', obj);
		});
	};

	addNavigation()
	{
		const prevBtn = wdc('<div class="carousel-control-prev" role="button" data-bs-slide="prev"/>');
		const nextBtn = wdc('<div class="carousel-control-next" role="button" data-bs-slide="next"/>');

		prevBtn.append(wdc('<span class="carousel-control-prev-icon"/>'));
		nextBtn.append(wdc('<span class="carousel-control-next-icon"/>'));

		prevBtn.addEventListener('click', () => this.prev());
		nextBtn.addEventListener('click', () => this.next());

		this.append(prevBtn, nextBtn);
	};

	addIndicators()
	{
		this.#indicatorWrapper = wdc('<ol class="carousel-indicators"/>');
		this.prepend(this.#indicatorWrapper);
	};

	updateActiveIndicator()
	{
		if (!this.#indicatorWrapper) return;

		//clear them out
		this.#indicatorWrapper.querySelectorAll('.active').forEach(item => item.classList.remove('active'));

		this.itemArray.forEach((item, idx) =>
		{

			if (item.classList.contains('active'))
			{
				//we are actually going to jump to the next slide from the one still active (since still sliding)
				if (idx == this.items.length - 1) idx = '0';
				else idx++;

				this.indicatorAt(idx).classList.add('active');
				return false;
			}
		});
	};

	updateIndicators()
	{
		if (!this.#indicatorWrapper) return;

		this.#indicatorWrapper.replaceChildren();

		this.itemArray.forEach((item, idx) =>
		{
			const indicator = wdc(`<button data-bs-slide-to="${idx}"></button>`);
			indicator.addEventListener('click', () => this.view(idx));

			this.#indicatorWrapper.append(indicator);

		});
	};

	/**
	 * override the proxy container item.  We can override 
	 * @param {*} data 
	 * @returns 
	 */
	createSlide(data)
	{
		return new WDCarouselItem(data);
	};

	cleanupCallback()
	{
		// Dispose of Bootstrap carousel instance
		if (this.#carousel) {
			this.#carousel.dispose();
			this.#carousel = null;
		}

		// Clean up child components
		if (this.#inner) {
			this.#inner = null;
		}

		// Clear references
		this.#indicatorWrapper = null;
		this.#options = null;

		super.cleanupCallback();
	}

};


customElements.define('wd-carousel', WDCarousel);
